import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/invoice/Index";

function App() {
  return (
    <Routes>
      <Route path="*" element={<Navigate replace to="/" />} />
      <Route path="/cobranca/:id" element={<Index />} />
    </Routes>
  );
}

export default App;